export * from "-!../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--5-0!../../../../../node_modules/vue-style-loader/index.js!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/postcss-loader/lib/index.js??ref--5-3!../../../../../node_modules/sass-loader/dist/cjs.js!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./header.vue?vue&type=style&index=1&id=8930d902&prod&lang=scss&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/header.vue?vue&type=style&index=1&id=8930d902&prod&lang=scss&
// module id = 327
// module chunks = 30